import { getInsightImageUrl } from "../utils/insightImage";

const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isLocal =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname.startsWith("192.168.") ||
  hostname.endsWith(".local");

const envApiBase = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

export const API_BASE =
  envApiBase ||
  (isLocal && !process.env.REACT_APP_FORCE_PROD_API
    ? `http://${hostname || "localhost"}:5000`
    : "");

export function resolveMediaUrl(imagePath) {
  return getInsightImageUrl(imagePath) || imagePath;
}
